import { Box } from '@fortum/elemental-ui';
import styled from 'styled-components';

export const Container = styled(Box)`
  background: linear-gradient(161.56deg, #115039 100%, #0c3727 100%); ;
`;
